import { Select, Form, Input, Button } from "antd";

import {
  ApiKey,Site
} from "../../model/model";

import { onFinishFailed } from "../helpers";

interface IProps {
  site: Site,
  initialValues: ApiKey;
  onFinish: (obj: ApiKey) => void;
  update?: boolean;
}

function ApiKeyForm(props: IProps) {
  const onFinish = (values: ApiKey) => {
    const apiKey :ApiKey = {
          id: values.id,
          role: values.role,
          name: values.name,
          subId: props.site.subId,
          orgId: props.site.orgId,
          siteId: props.site.id,
          lastSeenAt: 0
    }
    props.onFinish(apiKey);
  };

  return (
    <Form
      layout="vertical"
      initialValues={props.initialValues}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
            <Form.Item label="key" name="id" rules={[{ required: true, message: "Please enter a key!" }]}>
        <Input disabled={props.update}/>
      </Form.Item>
      <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter a name!" }]}>
        <Input />
      </Form.Item>
             <Form.Item label="Role" name="role" rules={[{ required: true, message: "Please select a userData role!" }]}>
            <Select > 
              <Select.Option value='Viewer'>Viewer</Select.Option>
              <Select.Option value='Editor'>Editor</Select.Option>
              <Select.Option value='Admin'>Admin</Select.Option>
            </Select>
       </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default ApiKeyForm;
